import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import moment from 'moment-timezone';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from 'primereact/inputswitch';
import appActions from '../../../appActions';
import storage from '../../../utils/storage';
import { actionTypeOptions, recurrenceOptions, dateTimeFormat, timeZonesOptions, selectedTimeZoneTemplate, timeZoneOptionTemplate } from '../../../utils/mics';
import TaskFormIcon from '../../../components/TaskFormIcon';
import ReminderRecurrenceForm from './ReminderRecurrenceForm';
import UserAutoCompleteInput from '../../../components/UserAutoCompleteInput';
import SiteAutoCompleteInput from '../../../components/SiteAutoCompleteInput';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog';
import axios from 'axios';

const configOpiton = window && window.config;

// // Get all time zones for Australia
// const australianTimeZones = moment.tz.names().filter(zone => zone.startsWith('Australia/'));

// console.log(australianTimeZones)

// // Map time zones with their current GMT offsets
// const timeZonesWithGMT = australianTimeZones.map(zone => {
//     const offsetInMinutes = moment.tz(zone).utcOffset();
//     const offsetHours = Math.floor(Math.abs(offsetInMinutes) / 60);
//     const offsetMinutes = Math.abs(offsetInMinutes) % 60;
//     const sign = offsetInMinutes >= 0 ? '+' : '-';
//     const gmtOffset = `GMT${sign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;
    
//     return { zone, gmtOffset };
// });

// console.log(timeZonesWithGMT);

const TaskForm = () => {

    const dropdownRef = useRef(null);

    const dispatch = useDispatch();
    const [allDay, setAllDay] = useState(false);
    const [reminderRecurrenceVisible, setReminderRecurrenceVisible] = useState(false);
    // const [taskRecurrence, setTaskRecurrence] = useState({});
    const [reminderPropsRecurrence, setReminderPropsRecurrence] = useState(null);
    const [selfAssign, setSelfAssign] = useState(false);
    const [confirmCreateDialog, setConfirmCreateDialog] = useState(false);
    const [confirmCreateMessage, setConfirmCreateMessage] = useState('');
    const [siteGroupMultiSelect, setSiteGroupMultiSelect] = useState([]);
    const [remindDateState, setRemindDateState] = useState(null);
    const [remindTimeState, setRemindTimeState] = useState(null);
    const [recurrenceMessage, setRecurrenceMessage] = useState('');
    const [recurrenceErrorMsg, setRecurrenceErrorMsg] = useState('');
    const [prevValue, setPrevValue] = useState(null);
    const currentUser = JSON.parse(storage.get('loginUser'));
    
    const priorityOptions = useSelector((state) => state.common.priorityList);

    const reminderOptions = useSelector((state) => state.common.reminderList);

    const siteGroupOptions = useSelector((state) => state.common.siteGroupList);

    const formik = useFormik({
        initialValues: {
            taskGroup: 'site',
            assignType: 'site',
            taskType: '',
            title: '',
            subject: '',
            description: '',
            remark: '',
            taskDate: '',
            dueDate: '',
            repeatType: '',
            priority: '',
            assignedTo: '',
            assignedBy: '',
            assignedDateTime: '',
            status: '',
            timeFrom: '',
            timeTo: '',
            timeZone: '',
            // attachmentRequired: '',
            siteId: '',
            reminder: false,
            recurrence: 'N',
            reminderTime: '',
            reminderOn: '',
            impact: '',
            actionBy: '',
            remainderEmail: 'Y', //set a default value to Y temporarily
            lastUpdatedBy: storage?.get('userName'),
            remindDate: '',
            remindTime: '',
            reminderProps: null,
            reminderRecurrence: 'N',
            allDay: 'N'
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (!data.taskDate) {
                errors.taskDate = 'Start Date is required.';
            }
            if (!data.dueDate) {
                errors.dueDate = 'End Date is required.';
            }
            if (!data.timeFrom) {
                errors.timeFrom = 'Start Time is required.';
            }
            if (!data.timeTo) {
                errors.timeTo = 'End Time is required.';
            }
            // if (!data.taskType) {
            //     errors.taskType = 'Site Group is required.';
            // }
            if (!data.title) {
                errors.title = 'Title is required.';
            }
            if (!data.subject) {
                errors.subject = 'Subject is required.';
            }
            if (!data.assignedTo) {
                if(data.assignType !== 'site-all') {
                    errors.assignedTo = 'Assigned to is required.';
                }
            }
            if (!data.impact) {
                errors.impact = 'Impact is required.';
            }
            if (!data.description) {
                errors.description = 'Description is required.';
            }
            if (!data.priority) {
                errors.priority = 'Priority is required.';
            }
            // if (!data.attachmentRequired) {
            //     errors.attachmentRequired = 'Select attachment required';
            // }
            if (!data.reminderTime && data.reminder) {
                errors.reminderTime = 'Reminder at is required.';
            }
            // if (!data.reminderOn && data.reminder) {
            //     errors.reminderOn = 'Reminder date is required.';
            // }
            if (!data.assignType && data.assignType) {
                errors.assignType = 'Assign Type is required.';
            }
            if (!data.timeZone) {
                errors.timeZone = 'Time Zone is required.';
            }
            if(data.taskDate && data.dueDate) {
                const beforeTaskDate = moment(data.dueDate).isBefore(moment(data.taskDate));
                if(beforeTaskDate) {
                    errors.dueDate = 'End Date must be after Start Date.';
                }
                else {
                    const taskDate = moment(data.taskDate);
                    const timeFrom = moment(data.timeFrom, 'HH:mm');
                    const dueDate = moment(data.dueDate);
                    const timeTo = moment(data.timeTo, 'HH:mm');

                    // Combine date and time correctly without formatting to string
                    const taskDateTime = taskDate.set({
                        hour: timeFrom.hour(),
                        minute: timeFrom.minute()
                    });
                    const dueDateTime = dueDate.set({
                        hour: timeTo.hour(),
                        minute: timeTo.minute()
                    });

                    // Now you can use isAfter correctly
                    const afterStartTime = taskDateTime.isAfter(dueDateTime);
                    if(afterStartTime) {
                        errors.timeTo = 'End Time must be after Start Time.';
                    }
                }
            }
            
            if(!remindDateState) {
                errors.remindDate = 'Remind Date is required.';
            }

            if(!remindTimeState) {
                errors.remindTime = 'Remind Time is required.';
            }
            if(remindDateState && remindTimeState) { 
                // const afterDueDate = moment(remindDateState).isAfter(moment(data.dueDate));
                const afterDueDate = moment(data.dueDate).isBefore(moment(remindDateState));
                if(afterDueDate) {
                    errors.remindDate = 'Remind Date must not be before End Date.';
                }
                else {
                    const remindDate = moment(remindDateState);
                    const remindTime = moment(remindTimeState, 'HH:mm');
                    const dueDate = moment(data.dueDate);
                    const timeTo = moment(data.timeTo, 'HH:mm');

                        // Combine date and time correctly without formatting to string
                    const remindDateTime = remindDate.set({
                        hour: remindTime.hour(),
                        minute: remindTime.minute()
                    });
                    const dueDateTime = dueDate.set({
                        hour: timeTo.hour(),
                        minute: timeTo.minute()
                    });

                    // Now you can use isAfter correctly
                    const afterStartTime = remindDateTime.isAfter(dueDateTime);
                    if(afterStartTime) {
                        errors.remindTime = 'Remind Time must be before End Time.';
                    }

                }

            }
            
            // if(getFromToTimeOrAllDayErrorMessage()) {
            //     errors.timeFrom = 'Please fill up Time From and To or All day';
            // }

            return errors;
        },
        onSubmit: (values) => {

            handleConfirmCreateDialog(values);
            
          
        },
    });

    useEffect(() => {
        // Initialize the previous value on mount
        setPrevValue(formik.values.reminderRecurrence);
    }, [formik.values.reminderRecurrence]);

    const callSaveMessageApi = (values) =>{

        // const taskDateTime = `${moment(values.taskDate).format('DD-MM-YYYY')} ${moment(values.timeFrom).format('HH:mm:ss')}`;
        // const dueDateTime = `${moment(values.dueDate).format('DD-MM-YYYY')} ${moment(values.timeTo).format('HH:mm:ss')}`;
        let taskDateTime, dueDateTime, reminderOn;

        if(values.allDay === 'N') {
            taskDateTime = `${moment.tz(values.taskDate, "Australia/Melbourne").format('DD-MM-YYYY')} ${moment.tz(values.timeFrom, "Australia/Melbourne").format('HH:mm:ss')}`;
            dueDateTime = `${moment.tz(values.dueDate, "Australia/Melbourne").format('DD-MM-YYYY')} ${moment.tz(values.timeTo, "Australia/Melbourne").format('HH:mm:ss')}`;
            reminderOn = `${moment.tz(remindTimeState, "Australia/Melbourne").format('DD-MM-YYYY')} ${moment.tz(values.timeFrom, "Australia/Melbourne").format('HH:mm:ss')}`
        }
        else {
            taskDateTime = `${moment(values.taskDate).format(dateTimeFormat)}`;
            dueDateTime = `${moment(values.dueDate).format(dateTimeFormat)}`;
            reminderOn = `${moment(remindTimeState).format(dateTimeFormat)}`;
        }
        const data = {
            ...values,
            assignType: values.assignType || '',
            taskDateTime: taskDateTime,
            dueDateTime: dueDateTime,
           // reminderOn: `${moment(remindDateState).format('DD-MM-YYYY')} ${moment(remindTimeState).format('HH:mm:ss')}`,
            reminderOn: reminderOn,
            reminder: values.reminder ? 'Y' : 'N',
            reminderEmail: 'Y',
            taskType: '',
            lastUpdatedBy: storage?.get('userName'),
         
        };
        if (values?.remindDate) {
            delete data.remindDate;
        }
        if (values?.remindTime) {
            delete data.remindTime;
        }
        if(data?.reminderOn === '') {
            delete data.reminderOn;
        }
        if(data?.reminderRecurrence === 'Y') {
            if(data?.reminderProps?.startDateTime && data?.reminderProps?.endDateTime){
                let startDateTime = moment(data?.reminderProps?.startDateTime, dateTimeFormat).toDate();
                let endDateTime = moment(data?.reminderProps?.endDateTime, dateTimeFormat).toDate();
                
                if(data?.reminderProps?.repeatBy === 'Hourly') {
                    // use startDateTime because it's only for the day itself
                    const strEndDate = moment(startDateTime).format('DD-MM-YYYY');
                    const newEndDate = moment(strEndDate + ' 23:59', dateTimeFormat).toDate();
        
                    data.reminderProps = {
                        ...data?.reminderProps,
                        startDateTime:  moment.tz(startDateTime, "Australia/Melbourne").format(dateTimeFormat),
                        endDateTime: moment(newEndDate).format(dateTimeFormat),
                    }
                }
                else {
                    data.reminderProps = {
                        ...data?.reminderProps,
                        startDateTime:  moment.tz(startDateTime, "Australia/Melbourne").format(dateTimeFormat),
                        endDateTime: moment.tz(endDateTime, "Australia/Melbourne").format(dateTimeFormat),
                    }
                }
    
            }
        } 
        if(data?.reminderRecurrence === 'N') {
            delete data.reminderProps;
        }
        
        handleCreate(data);

    }

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    // const getTaskTimeAllDayErrorMessage = () => {
    //     return (
    //         formik.touched['timeFrom'] && formik.errors['timeFrom'] && (
    //             <small className="p-error">{formik.errors['timeFrom']}</small>
    //         )
    //     );
    // };

    // const getFromToTimeOrAllDayErrorMessage = () => {
    //     const fromTime = formik.values.timeFrom;
    //     const toTime = formik.values.timeTo;
    //     let error = false;

    //     if(allDay && (fromTime !== '' && fromTime !== null && toTime !== '' && toTime != null)){
    //         setTimeFromToAllDayError(false);
    //         return error;
    //     }

    //     if (!(fromTime !== '' && fromTime !== null && toTime !== '' && toTime !== null)) {
    //         setTimeFromToAllDayError(true);
    //         error = true;
    //     }
    //     else {
    //         setTimeFromToAllDayError(false);
    //     }

    //     return error;
    // };

    const handleCreate = (data) => {
        delete data.taskDate;
        delete data.timeFrom;
        delete data.timeTo;
        data['assignedBy'] = storage.get('userId');
        data['assignedDateTime'] = data.taskDateTime;
        
        // if (!isEmptyObj(taskRecurrence)) {
        //     data['taskRecurrence'] = taskRecurrence;
        // }
        
        dispatch(appActions.TASK_CREATE_REQUEST(data));
    };

    // const handleRecurrence = (data) => {
    //     const { repeatBy, startDateTime } = data;
    //     formik.setFieldValue('taskDate', moment(startDateTime, dateTimeFormat).toDate());
    //     formik.setFieldValue('repeatType', repeatBy);
    //     setTaskRecurrence(data);
    //     handleRecurrenceMessage(data);
    //     formik.setFieldValue('recurrence', 'Y');
    // };

    // const handleCancelRecurrence = () => {
    //     formik.setFieldValue('recurrence', 'N');
    //     setRecurrenceMessage('');
    // };

    const handleReminderRecurrence = (data) => {
        const { repeatBy, startDateTime } = data;
        setRemindDateState(moment(startDateTime, dateTimeFormat).toDate());
        setRemindTimeState(moment(startDateTime, dateTimeFormat).toDate());
        formik.setFieldValue('reminderOn', moment(startDateTime, dateTimeFormat).toDate());
        formik.setFieldValue('repeatType', repeatBy);
        formik.setFieldValue('reminderProps',  data);
        // setTaskRecurrence(data);
        setReminderPropsRecurrence(data);
        handleRecurrenceMessage(data);
        formik.setFieldValue('reminderRecurrence', 'Y');
    };

    const handleCancelReminderRecurrence = () => {
        // formik.setFieldValue('reminderRecurrence', 'N');
        // setRecurrenceMessage('');
    };

    const handleSearchUser = (user) => {
        const { siteId } = user;
        setSelfAssign(false);
        formik.setFieldValue('assignedTo', user.userId);
        if (siteId) {
            let storeArr = siteId.split(',');
            formik.setFieldValue('siteId', storeArr[0]);
        }
    };

    // const handleSearchOperatorName = (user) => {
    //     formik.setFieldValue('actionBy', user.userId);
    // };

    // const handleSearchSite = (site) => {
    //     const { siteId } = site;
    //     if (siteId) {
    //         formik.setFieldValue('assignedTo', siteId);
    //         formik.setFieldValue('siteId', siteId);
    //     }
    // };

    const handleSiteAssignedTo = (siteId) => {
        formik.setFieldValue('assignedTo', siteId);
    };

    const handleDraft = () => {
        formik.setFieldValue('status', 'DRAFT');
        formik.handleSubmit();
    };

    const handleNew = () => {
        formik.setFieldValue('status', 'NOT_STARTED');
      //  formik.handleSubmit();
        setConfirmCreateDialog(false);
        callSaveMessageApi(formik.values);
    };

    const handleSelfAssign = () => {
        const { siteId } = currentUser;
        setSelfAssign(true);
        formik.setFieldValue('assignedTo', storage.get('userId'));
        if (siteId) {
            let storeArr = siteId.split(',');
            formik.setFieldValue('siteId', storeArr[0]);
        }
    };

    const handleRepeatChange = (e) => {
        const currentValue = e.value;
    
        // Check if the value has changed
        if (currentValue !== prevValue) {
          console.log('Value changed:', currentValue);
          setPrevValue(currentValue);
          formik.setFieldValue('reminderRecurrence', currentValue);
          setRepeatChange(currentValue)
        } else {
          console.log('Same value selected again');
          if(currentValue === 'Y'){
            setReminderRecurrenceVisible(true)
          }
        
        }
      };

    const setRepeatChange = (currentValue) => {
      
        if(!validateRecurrence()) {
            return;
        }
        // formik.setFieldValue('recurrence', e.value);
        //formik.setFieldValue('reminderRecurrence', e.value);

        if (currentValue === 'Y') {
            const taskDate = formik.values.taskDate === '' ? moment(new Date()).format('DD-MM-YYYY') : moment(formik.values.taskDate).format('DD-MM-YYYY');
            const taskTime = formik.values.timeFrom === '' ? moment(new Date()).format('HH:mm:ss') : moment(formik.values.timeFrom).format('HH:mm:ss');
            const taskDateTime = moment(taskDate + ' ' + taskTime, dateTimeFormat ).toDate();
                                
            formik.setFieldValue('taskDate', taskDateTime);

            const dueDate = formik.values.dueDate === '' ? moment(new Date()).format('DD-MM-YYYY') : moment(formik.values.dueDate).format('DD-MM-YYYY');
            const dueTime = formik.values.timeTo === '' ? moment(new Date()).format('HH:mm:ss') : moment(formik.values.timeTo).format('HH:mm:ss');
            const dueDateTime = moment( dueDate + ' ' + dueTime, dateTimeFormat ).toDate();
                                
            formik.setFieldValue('dueDate', dueDateTime);

            // setRvisible(true);
            setReminderRecurrenceVisible(true);
        } else if (currentValue === 'N') {
            setRecurrenceMessage('');
        }
    };

    // const handleRepeatClick = (e) => {
    //     // const previousRecurrenceValue = formik.values.recurrence;
    //     const previousReminderRecurrenceValue = formik.values.reminderRecurrence;
    //     if(!validateRecurrence()) {
    //         return;
    //     }

    //     // if(previousRecurrenceValue === 'Y') {
    //     //     setRvisible(true);
    //     // }
    //     if(previousReminderRecurrenceValue === 'Y') {
    //         setReminderRecurrenceVisible(true);
    //     }
    // }

    const handleRecurrenceMessage = (data) => {
        const repeatBy = data.repeatBy;
        const reminderStartDateTime = moment(data.startDateTime, dateTimeFormat).toDate()
        const reminderEndDateTime = moment(data.endDateTime, dateTimeFormat).toDate()

        if(repeatBy === 'Hourly') {
            let strMsg = 'Occurs <strong> every ' + data.repeatEvery + ' hours </strong> effective ' 
                + moment(reminderStartDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(reminderStartDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Daily') {
            
            let strMsg = 'Occurs <strong> every ' + data.repeatEvery + ' days </strong> effective ' 
            + moment(reminderStartDateTime).format('DD MMM YYYY') 
            + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
            + ' from ' + moment(reminderStartDateTime).format('h:mma')
            + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Weekly') {
            const arrRepeatDays = data.repeatDays.split(',').map(Number);
             // Map the numbers to weekday names using moment.js
             const dayNames = arrRepeatDays.map((day) => moment().isoWeekday(day).format('dddd'));

             // Join the array into a comma-separated string
             const formattedDays = data.repeatDays !== '' ? dayNames.join(', ') : '';
 
             let strMsg = 'Occurs <strong> every ' + data.repeatEvery + ' </strong>weeks '
                 + formattedDays + ' effective ' 
                 + moment(reminderStartDateTime).format('DD MMM YYYY') 
                 + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                 + ' from ' + moment(reminderStartDateTime).format('h:mma')
                 + ' to ' + moment(reminderEndDateTime).format('h:mma');
             setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Monthly') {
            const dayPart = moment(reminderStartDateTime, "D/MM/YYYY").date();

            let strMsg = 'Occurs <strong> day ' + dayPart + ' of every ' 
                + data.repeatEvery + ' months </strong> effective ' 
                + moment(reminderStartDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(reminderStartDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Yearly') {
            // Parse the date string and format it as "MMMM D"
            const formattedDate = moment(data.startDateTime).format("MMMM D");

            let strMsg = 'Occurs <strong> every ' + formattedDate 
                + ' </strong>effective ' 
                + moment(reminderStartDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(reminderStartDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
    };

    const validateRecurrence = () => {
        
        if(!formik.values.taskDate || !formik.values.dueDate || !formik.values.timeFrom || !formik.values.timeTo) {
            setRecurrenceErrorMsg('Start Date, Start Time, End Date, End Time is required.');
            return false;
        }
        else {
            setRecurrenceErrorMsg('');
            return true;
        }
        
    };

    const clearRepeatChange = (e) => {
        formik.setFieldValue('recurrence', null);
        // setRvisible(false);
    }

    const handleAssignTypeChange = (e) => {
        formik.setFieldValue('assignType', e?.value);
        formik.setFieldValue('assignedTo', '');
        setSiteGroupMultiSelect([]);
    };

    const handleStartDateToRemindDate = (e) => {
        const value = e.value;
        formik.values.taskDate = value;
        setRemindDateState(value);
    };

    const handleStartTimeToRemindTime = (e) => {
        const value = e.value;
        formik.values.timeFrom = value;
        if(formik.values.timeTo === "")
        {
            formik.values.timeTo = value;
        }
        else if(formik.values.timeTo !== "" && moment(value).isAfter(formik.values.timeTo)){
            formik.values.timeTo = value;
        }
        setRemindTimeState(value);
    };

    const handleRemindDate = (e) => {
        const value = e.value;
        setRemindDateState(value);
    };

    const handleRemindTime = (e) => {
        const value = e.value;
        setRemindTimeState(value);
    };

    const handleIntervalToRemindTime = (e) => {
        const value = e.value;

        formik.values.reminderTime = value;

        if(remindTimeState) {
            const regexMI  = /^(\d+)-MI$/; // Regex to check if input ends with "-MI" and has digits before it
            const regexHH = /^(\d+)-HH$/;  // Regex to check if input ends with "-HH"

            let match; 
            
            match = value.match(regexMI);
        
            if (match) {
            const minutesToAdd = parseInt(match[1], 10); // Extract the number before "-MI"
            const newDate = moment(remindTimeState).subtract(minutesToAdd, 'minutes').toDate(); // Add the minutes to current time
            setRemindTimeState(newDate); // Set the new time formatted
            return;
            }

            match = value.match(regexHH);
        
            if (match) {
            const hoursToAdd = parseInt(match[1], 10); // Extract the number before "-MI"
            const newDate = moment(remindTimeState).subtract(hoursToAdd, 'hours').toDate(); // Add hours to current time
            setRemindTimeState(newDate); // Set the new time formatted
            }
        }
    };

    const handleAllDay = (value) => {
        setAllDay(value);
        formik.values.allDay = value ? 'Y' : 'N';
        setRecurrenceMessage('');

        if(value) {
            formik.values.reminderRecurrence = 'N';
            if(formik.values.taskDate) {
                const taskDate = moment(formik.values.taskDate).format('DD-MM-YYYY');

                formik.values.timeFrom = moment(taskDate + ' 00:00', dateTimeFormat).toDate();

                formik.values.timeTo = moment(taskDate + ' 23:59', dateTimeFormat).toDate();

                formik.values.taskDate = formik.values.timeFrom;

                formik.values.dueDate = formik.values.timeTo;

                setRemindDateState(moment(taskDate + ' 00:00', dateTimeFormat).toDate());

                setRemindTimeState(moment(taskDate + ' 00:00', dateTimeFormat).toDate());
            }
            else {
                const taskDate = moment(new Date()).format('DD-MM-YYYY');

                formik.values.timeFrom = moment(taskDate + ' 00:00', dateTimeFormat).toDate();

                formik.values.timeTo = moment(taskDate + ' 23:59', dateTimeFormat).toDate();
            
                formik.values.taskDate = formik.values.timeFrom;

                formik.values.dueDate = formik.values.timeTo;

                setRemindDateState(moment(taskDate + ' 00:00', dateTimeFormat).toDate());

                setRemindTimeState(moment(taskDate + ' 00:00', dateTimeFormat).toDate());
            }
        }
       
    };

    const handleConfirmCreateDialog = async () => {

        if(formik.values.assignType != null && formik.values.assignType === 'site-group') {
            const assignedTo = formik.values?.assignedTo || '';
            
            const params = {
                fetchSiteGroupCode: assignedTo
            }
            try {
                const response = await axios.get(`${configOpiton?.END_POINT}/communication/v1/sitegroup`, {
                    headers: {
                        'Authorization': storage.getToken()
                    },
                    params
                });

                if (response.status === 200) {
                    const siteGroups = response?.data?.data || '';
                    const concatenatedSiteNames = siteGroups.map(item => item.siteName).join(',');
                    setConfirmCreateMessage(`Are you sure to send this message to Site Groups: ${concatenatedSiteNames}?`);
                    setConfirmCreateDialog(true);
                }
            } catch (error) {
                console.error('Error retriving siteGroups:', error);
                
            }
        }
        else if (formik.values.assignType === 'site') {
            const assignedTo = formik.values?.assignedTo || '';
            
            const params = {
                fetchSiteCode: assignedTo
            }
            try {
                const response = await axios.get(`${configOpiton?.END_POINT}/communication/v1/site`, {
                    headers: {
                        'Authorization': storage.getToken()
                    },
                    params
                });

                if (response.status === 200) {
                    const sites = response?.data?.data || '';
                    const concatenatedSiteIds = sites.map(item => item.title).join(', ');
                    setConfirmCreateMessage(`Are you sure to send this message to Sites: ${concatenatedSiteIds}?`);
                    setConfirmCreateDialog(true);
                }
            } catch (error) {
                console.error('Error retriving sites:', error);
                
            }

        }
        else if (formik.values.assignType === 'site-all') {
            setConfirmCreateMessage(`Are you sure to send this message to All Sites?`);
            setConfirmCreateDialog(true);
        }
        else if (formik.values.assignType === 'user') {
            setConfirmCreateMessage(`Are you sure to send this message to ${formik.values.assignedTo} ?`);
            setConfirmCreateDialog(true);
        }
    };

    const handleSiteGroupMultiSelect = (value) => {
        const selectedValue = value;
        setSiteGroupMultiSelect(value);
        formik.setFieldValue('assignedTo', selectedValue?.join(',') || '');
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit} className='mt-3'>
                <div className="grid formgrid mt-1">

                    {/* <div className="field col-4">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-type-icon.svg'} />
                            <span>Site Group</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="taskType"
                            name="taskType"
                            value={formik.values.taskType}
                            options={taskOptions}
                            onChange={formik.handleChange}
                            placeholder="Site Group"
                        />
                        

                        {getFormErrorMessage('taskType')}
                    </div> */}

                    <div className="field col-6">
                        <label htmlFor="assignType" className="flex align-items-center required" >Audience</label>
                        <Dropdown
                            className="w-full"
                            id="assignType"
                            name="assignType"
                            value={formik.values.assignType}
                            options={actionTypeOptions}
                            onChange={(e) =>handleAssignTypeChange(e)}
                            placeholder="Choose audience"
                            optionLabel="name"
                            optionValue='code'
                        />
                        {getFormErrorMessage('assignType')}
                    </div>

                    
                    <div className="field col-6">
                        { formik.values.assignType !== 'site-all' &&
                        <label htmlFor="assignType" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'assigned-to.svg'} />
                            <span className='mr-auto'>Assign to {formik.values.assignType === 'user' ? 'User' : formik.values.assignType === 'site-group' ? 'Site Group' : 'Site'}</span>
                           
                            { (formik.values.assignType === null ||  formik.values.assignType === 'user') && <span className="underline cursor-pointer floatRight" onClick={handleSelfAssign} > Assign to me </span>}
                        </label>
                        }
                        { (formik.values.assignType === null || formik.values.assignType === 'user') && 
                            <UserAutoCompleteInput handleSearchUser={handleSearchUser} selfAssign={selfAssign} currentUser={formik.values.assignedTo} />
                        }
                        { (formik.values.assignType === 'site') && 
                            <SiteAutoCompleteInput handleSiteAssignedTo={handleSiteAssignedTo} assignedTo={formik.values.assignedTo}/>
                        }
                        { formik.values.assignType === 'site-group' && 
                            <MultiSelect 
                                id="assignedTo"
                                value={siteGroupMultiSelect} 
                                onChange={(e) => handleSiteGroupMultiSelect(e.value)} 
                                options={siteGroupOptions}
                                optionLabel="label" 
                                filter 
                                placeholder="Select Site Group" 
                                className="w-full"
                                maxSelectedLabels={3} />
                        }
                        {getFormErrorMessage('assignedTo')}
                    </div>

                </div>

                <div className="grid formgrid">

                    <div className="field col-6 mt-1">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-title.svg'} />
                            <span>Message Subject</span>
                        </label>
                        <InputTextarea
                            className="w-full"
                            id="subject"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            placeholder="Message Subject"
                            rows={2}
                            maxLength={48}
                        />
                       
                        {getFormErrorMessage('subject')}
                    </div>

                    <div className="field col-6 mt-1">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-title.svg'} />
                            <span>Message Title</span>
                        </label>
                         <InputTextarea
                            className="w-full"
                            id="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            placeholder="Message Title"
                            rows={2}
                            maxLength={20}
                        />
                        {getFormErrorMessage('title')}
                    </div>

                    <div className="field col-12 mt-1">
                        <label htmlFor="task" className="flex align-items-center required">
                            <TaskFormIcon iconName={'description.svg'} />
                            <span>Message description</span>
                        </label>
                        <InputTextarea
                            className="w-full"
                            id="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            placeholder="Message description"
                            rows={2}
                            maxLength={210}
                        />
                        {getFormErrorMessage('description')}
                    </div>

                </div>

                <div className="grid formgrid mt-1">

                    <div className="field col-4">
                        <label htmlFor="priority" className="flex align-items-center required">
                            <TaskFormIcon iconName={'priority-icon.svg'} />
                            <span>Priority</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="priority"
                            value={formik.values.priority}
                            options={priorityOptions}
                            onChange={formik.handleChange}
                            placeholder="Priority"
                        />
                        {getFormErrorMessage('priority')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="impact" className="flex align-items-center required" > Impact </label>
                        <InputText className="w-full" id="impact" value={formik.values.impact} onChange={formik.handleChange} placeholder="impact"/>
                        {getFormErrorMessage('impact')}
                    </div>

                    {/* <div className="field col-4">
                        <label htmlFor="actionBy" className="flex align-items-center" > Operator Name </label>
                        <UserAutoCompleteInput handleSearchUser={handleSearchOperatorName}  currentUser={formik.values.actionBy} placeholderTxt='Search for Operator Name'/>
                        {getFormErrorMessage('actionBy')}
                    </div> */}

                    
                    <div className="field col-4">
                        <div className="grid formgrid mt-1">
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'calendar-icon.svg'} />
                                    <span>Start Date</span>
                                </label>

                                <Calendar
                                    className="w-full"
                                    id="taskDate"
                                    value={formik.values.taskDate}
                                    onChange={(e) => {
                                        handleStartDateToRemindDate(e);
                                        formik.handleChange(e);
                                    }}
                                    placeholder="Date"
                                    minDate={new Date()}
                                    dateFormat="dd/mm/yy"
                                />
                                {getFormErrorMessage('taskDate')}
                            </div>
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'clock-icon.svg'} />
                                    <span>Start Time</span>
                                </label>

                                <Calendar id="timeFrom" 
                                    value={formik.values.timeFrom} 
                                    onChange={(e) => {
                                        handleStartTimeToRemindTime(e);
                                        formik.handleChange(e);
                                    }} 
                                    hourFormat="12"
                                    timeOnly />
                                {getFormErrorMessage('timeFrom')}
                            </div>
                        </div>
                        {/* {getTaskTimeAllDayErrorMessage()} */}
                    </div>

                </div>

                <div className="grid formgrid mt-1">


                    <div className="field col-4">
                        <div className="grid formgrid mt-1">
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'calendar-icon.svg'} />
                                    <span>End Date</span>
                                </label>

                                <Calendar
                                    className="w-full"
                                    id="dueDate"
                                    value={formik.values.dueDate}
                                    onChange={formik.handleChange}
                                    placeholder="Date"
                                    minDate={formik.values.taskDate || new Date()}
                                    dateFormat="dd/mm/yy"
                                    disabled={formik.values.allDay === 'Y'}
                                />
                                {getFormErrorMessage('dueDate')}
                            </div>
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'clock-icon.svg'} />
                                    <span>End Time</span>
                                </label>

                                <Calendar id="timeTo" 
                                    value={formik.values.timeTo} 
                                    onChange={formik.handleChange}
                                    disabled={formik.values.allDay === 'Y'}
                                    minDate={remindTimeState}
                                    hourFormat="12"
                                    timeOnly />
                                {getFormErrorMessage('timeTo')}
                            </div>
                        </div>
                        
                    </div>

                    <div className="field col-4">
                            <label htmlFor="repeat" className="flex align-items-center required" >
                                <TaskFormIcon iconName={'clock-icon.svg'} />
                                <span>Time Zone</span>
                            </label>
                        <Dropdown filter value={formik.values.timeZone}
                            className='w-full'
                                onChange={(e) => formik.setFieldValue('timeZone', e.value)}
                                options={timeZonesOptions}
                                optionLabel="name"
                                optionValue="name"
                                placeholder="Select a timezone"
                                valueTemplate={selectedTimeZoneTemplate}
                                itemTemplate={timeZoneOptionTemplate} 
                                id="timeZone"
                                name="timeZone"
                            />
                            {getFormErrorMessage('timeZone')}
                    </div>

                    <div className="field col-2">
                        <label style={{ height: '15px' }}> </label>
                        <div className="flex w-full align-items-center gap-10 h-40">
                            <InputSwitch
                                className="mr-1"
                                checked={allDay}
                                onChange={(e) => handleAllDay(e.value)}
                            />
                            <label className="p-checkbox-label">All day</label>
                        </div>
                    </div>

                </div>

                <div className="grid formgrid mt-1 align-items-center">
                    <div className="field col-2">
                            <label htmlFor="repeat" className="flex align-items-center" >
                                <TaskFormIcon iconName={'repeat-type.svg'} />
                                <span>Reminder Recurrence</span>
                            </label>
                            {/* <Dropdown
                                ref={dropdownRef}
                                className="w-full"
                                id="recurrence"
                                value={formik.values.recurrence}
                                options={recurrenceOptions}
                                onChange={handleRepeatChange}
                                onClick={handleRepeatClick}
                                onShow={clearRepeatChange}
                                placeholder="Select"
                            /> */}
                           <Dropdown
                                ref={dropdownRef}
                                className="w-full"
                                id="recurrence"
                                value={formik.values.reminderRecurrence}
                                options={recurrenceOptions}
                                onChange={handleRepeatChange}
                                onClick={handleRepeatChange}
                                onShow={clearRepeatChange}
                                placeholder="Select"
                                disabled={formik.values.allDay === 'Y'}
                                />
                            {recurrenceErrorMsg && <small className="p-error">{recurrenceErrorMsg}</small>}
                    </div>

                    <div className="col-10">
                        <label className="flex align-items-center">
                            <p className='m-0 pt-18'  dangerouslySetInnerHTML={{ __html: recurrenceMessage }} ></p>
                        </label>
                    </div>

                </div>

                <div className="grid formgrid mt-1">

                    {/* <div className="field col-4 pt-25">
                        <div className="flex align-items-center">
                            <InputSwitch
                                id="reminder"
                                name="reminder"
                                checked={formik.values.reminder}
                                onChange={formik.handleChange}
                            />
                            <label className="p-checkbox-label ml-2">
                                Reminder
                            </label>
                        </div>
                    </div> */}
                  
                    
                   
                    {/* { (formik.values.reminderTime === null || formik.values.reminderTime === 'CUSTOM-TIME') &&  */}
                        <div className="field col-4">
                            <div className="grid formgrid mt-1">
                                <div className="field col-6">
                                    <label htmlFor="task" className="flex align-items-center required">
                                        <TaskFormIcon iconName={'calendar-icon.svg'} />
                                        <span>Reminder Date</span>
                                    </label>

                                    <Calendar
                                        className="w-full"
                                        id="remindDate"
                                        value={remindDateState}
                                        onChange={(e) => handleRemindDate(e)}
                                        placeholder="Date"
                                        maxDate={formik.values.dueDate}
                                        dateFormat="dd/mm/yy"
                                        disabled={formik.values.reminderRecurrence !== 'N'}
                                    />
                                    {getFormErrorMessage('remindDate')}
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="remindTime" className="flex align-items-center required">
                                        <TaskFormIcon iconName={'clock-icon.svg'} />
                                        <span>Reminder Time</span>
                                    </label>

                                    <Calendar id="remindTime" 
                                        value={remindTimeState} 
                                        onChange={(e) => handleRemindTime(e)} 
                                        disabled={formik.values.reminderRecurrence !== 'N'}
                                        hourFormat="12"
                                        timeOnly />
                                    {getFormErrorMessage('remindTime')}
                                </div>
                            </div>
                            
                        </div>
                    {/* } */}

                    <div className="field col-4">
                        <label htmlFor="reminderTime" className="flex align-items-center">
                            <i className="pi pi-clock mr-2" style={{ fontSize: '1rem' }} ></i>
                            <span>Reminder Interval</span>
                        </label>
                        <Dropdown
                            name="reminderTime"
                            value={formik.values.reminderTime}
                            options={reminderOptions}
                            onChange={(e) => handleIntervalToRemindTime(e)}
                            placeholder="Select a reminder"
                            className='w-full'
                            disabled={formik.values.reminderRecurrence !== 'N'}
                        />
                        {getFormErrorMessage('reminderTime')}
                    </div>

                    {/* <div className="field col-4">
                        <label htmlFor="attachmentRequired" className="flex align-items-center">
                            <TaskFormIcon iconName={'attachment-required.svg'} />
                            <span className='required'>Completion attachment</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="attachmentRequired"
                            value={formik.values.attachmentRequired}
                            options={completionOptions}
                            onChange={formik.handleChange}
                            placeholder="Completion attachment"
                        />
                        {getFormErrorMessage('attachmentRequired')}
                    </div> */}

                    <div className="field col-12">
                        <label htmlFor="remark" className="flex align-items-center">
                            Remark
                        </label>
                        <InputTextarea 
                            autoResize
                            className="w-full"
                            id="remark" 
                            value={formik.values.remark}
                            onChange={formik.handleChange}
                            rows={5} 
                            cols={30} />
                    </div>
                 
                    <div className="field col-12">
                        <div className="flex justify-content-end mt-4">
                            <ConfirmDialog 
                                header="Confirmation"
                                style={{ width: '350px' }}
                                breakpoints={{ '1100px': '400px', '960px': '300px' }}
                                visible={confirmCreateDialog} 
                                onHide={() => setConfirmCreateDialog(false)} 
                                message={confirmCreateMessage}
                                accept={handleNew}
                            />
                            <Button label="Save as draft" className="p-button-secondary mr-2" onClick={handleDraft} type="button" />
                            <Button type="submit" label="Create" severity="basic"/>
                        </div>
                    </div>
                </div>
            </form>

            {/* <Dialog header="Reminder Recurrence" visible={rVisible} style={{ width: '450px' }}
                onHide={() => {
                    if (!rVisible) return;
                    setRvisible(false);
                    handleCancelRecurrence();
                }}
            >
                <RecurrenceForm 
                    visible={setRvisible} 
                    handleRecurrence={handleRecurrence} 
                    taskDateTime={formik.values.taskDate}
                    recurrenceInfo={taskRecurrence}
                    handleCancelRecurrence={handleCancelRecurrence}
                />
            </Dialog> */}

            <Dialog header="Reminder Recurrence" visible={reminderRecurrenceVisible} style={{ width: '450px' }}
                onHide={() => {
                    if (!reminderRecurrenceVisible) return;
                    setReminderRecurrenceVisible(false);
                    handleCancelReminderRecurrence();
                }}
            >
                <ReminderRecurrenceForm 
                    visible={setReminderRecurrenceVisible} 
                    handleReminderRecurrence={handleReminderRecurrence} 
                    taskDateTime={formik.values.taskDate}
                    dueDateTime={formik.values.dueDate}
                    recurrenceInfo={reminderPropsRecurrence}
                    handleCancelReminderRecurrence={handleCancelReminderRecurrence}
                />
            </Dialog>
        </>
    );
};


export default TaskForm;
